import { CardComponent } from "../types/types";
import * as components from "./";

export const componentMap: { [name: string]: CardComponent } = components;
